module.exports = __webpack_public_path__ + "static/media/Nunito-Regular.938de2a9.woff2";